import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getTenants = async (params?: any) => apiList('tenants', params);
export const getTenantById = async (id: number | string) => apiGet('tenants', id);
export const createTenant = async (data: any) => apiCreate('tenants', data);
export const updateTenant = async (id: number | string, data: any) => apiUpdate('tenants', id, data);
export const deleteTenant = async (id: number | string) => apiDelete('tenants', id);
